import { render, staticRenderFns } from "./MaintainerDetails.vue?vue&type=template&id=7c516b0c&scoped=true&"
import script from "./MaintainerDetails.vue?vue&type=script&lang=js&"
export * from "./MaintainerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c516b0c",
  null
  
)

export default component.exports